<script lang="ts" setup>
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useCategoryStore } from '@/stores/category';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const $props = defineProps<{
  modelValue?: string;
  type?: string;
  rootFormData?: any;
}>();

const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);
const categoryStore = useCategoryStore();
const { sortedList: categories } = storeToRefs(categoryStore);
const value = ref($props.modelValue);
const processedCategories = computed(() => {
  if ($props.type === 'subcategory') {
    return categories.value.find((item) => item.uid === $props.rootFormData.category_uid)?.subcategories;
  }
  return categories.value;
});
const handleChange = () => {
  $props.rootFormData.subcategory_uid = '';
  $emit('change', value.value);
  $emit('update:value', value.value);
  $emit('update:modelValue', value.value);
};
</script>
<template>
  <el-select v-model="value" clearable @change="handleChange">
    <el-option v-for="item in processedCategories" :key="item.uid" :label="item.name_translations?.[locale] || item.name" :value="item.uid"></el-option>
  </el-select>
</template>
